import React, { useEffect, useState } from "react";


import TextField from "@material-ui/core/TextField";
import GridItem from "components/Grid/GridItem.jsx";

import BivPagination from 'components/BivPagination/BivPagination.jsx'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import db from "db/db.jsx";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";
import { AdapterMoment } from "@mui/x-date-pickers-pro/AdapterMoment";
import {
    Typography,
    Collapse,
    Grid,
    CircularProgress,
} from "@mui/material";
import Button from "components/CustomButtons/Button.jsx";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Switch from '@mui/material/Switch';

import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

moment.locale("es");

export default function ActionInformation(props) {
   
    const [valueSince, setValueSince] = React.useState(
        moment().subtract(7, 'days').startOf("day")
    );
    const [valueTo, setValueTo] = React.useState(
        moment().endOf("day")
    );
    const [user, setUser] = React.useState(null);


    const [logs, setLogs] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNumber, pageNumberChange] = React.useState(1);
    const [totalRegistry, setTotalRegistry] = React.useState(0);

    function actionData(x, y, z, w) {
        if (loading) {
            return true
        }
        setLoading(true)
        if (z) {
            pageNumberChange(z)
        }
        var myHeaders = new Headers();
        let _token = localStorage.getItem("fb_jwt");
        myHeaders.append("Authorization", "Bearer " + _token);
        var formdata = new FormData();
        formdata.append("page", z || pageNumber);
        formdata.append("start", x);
        formdata.append("end", y);
        if (user) {
            formdata.append("userID", user);
        }
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
        };

        fetch(
            global.Direction_Back_panel + "/logsAuditor/settings/enviromentSettings",
            requestOptions
        )
            .then((response) => response.json())

            .then((result) => {
                const _logs = result.data;
                setTotalRegistry(_logs.total)

                const endData = []

                _logs.data.map((item, b) => {
                    const olddata = JSON.parse(item.old);
                    const newdata = JSON.parse(item.new);
                    fieldsGroup.map((sections, b) => {
                        const fields = sections.fields
                        const changes = []
                        fields.map((field, index) => {


                            let oldit
                            let newit

                            if (Array.isArray(field)) {
                                oldit = { a: olddata[field[0]], l: olddata[field[1]], sm: olddata[field[2]] }
                                newit = { a: newdata[field[0]], l: newdata[field[1]], sm: newdata[field[2]] }
                                field = "pc"
                            }
                            else {
                                oldit = olddata[field]
                                newit = newdata[field]
                            }

                            if (JSON.stringify(oldit) !== JSON.stringify(newit)) {

                                let oldlist = []
                                let newlist = []

                                let newItems = []
                                let deletedItems = []
                                if (oldit.l) {

                                    if (newit.l) {
                                        newit.l.map((a, b) => {
                                            newlist.push(a.pname)
                                        })
                                        oldit.l.map((a, b) => {
                                            oldlist.push(a.pname)
                                        })

                                        newlist.map((a) => {
                                            if (!oldlist.includes(a)) {
                                                newItems.push(a)
                                            }
                                        })

                                        oldlist.map((a) => {
                                            if (!newlist.includes(a)) {
                                                deletedItems.push(a)
                                            }
                                        })
                                    }
                                    if (newItems.length > 0 || deletedItems.length > 0) {
                                        newit.l = {}
                                        if (newItems.length > 0) {
                                            newit.l.new = newItems
                                        }
                                        if (deletedItems.length > 0) {
                                            newit.l.del = deletedItems
                                        }
                                    }

                                }

                                changes.push([field, oldit, newit])
                            }


                        })
                        if (changes.length > 0) {
                            endData.push({ ty: sections.ty, title: sections.title, changes: changes, time: item.time, rolName: item.rolName, auditor: item.auditor })
                        }
                    })
                })
                setLogs(endData);
                setLoading(false)

                return true
            })
            .catch((error) => console.log("error", error));
    }
    const [users, setUsers] = React.useState([]);

    useEffect(() => {
        db.getUsers((_res) => {
            setUsers(_res ? _res : [])
        }, () => {

        })
        actionData(valueSince.valueOf(), valueTo.valueOf());
    }, []);

    const fieldsGroup = [
        {
            ty: 1,
            fields: ["ec"],
            title: "Ambiente",
        },
        {
            ty: 2,
            fields: ["bl", "cs", "mc", "msc", "vc", ["pc", "pd", "spc"], "vm"],
            title: "Ambiente",
        },
    ];

    const texts = {

        //ambiente
        ec: 'Control de ambiente.',
        bl: "Controlar del nivel de batería.",
        cs: "Controlar cantidad de espacio libre de almacenamiento.",

        mc: "Controlar cantidad de monitores.",
        msc: "Controlar el nivel de volumen del micrófono",
        pc: "Controlar procesos abiertos.",
        vc: "Controlar cámaras virtuales",

        vm: "Controlar ejecución de máquinas virtuales.",
    };
    const [openF, setOpenF] = React.useState([]);
    const [openI, setOpenI] = React.useState([]);


    function RenderItemCategory(props) {

        const row = props.data
        const index = props.index
        const fecha = moment(row.time).format("DD/MM/YYYY");
        const hora = moment(row.time).format("HH:mm");
        return (
            <React.Fragment>
                <TableRow
                    key={1}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                    <TableCell>
                        
                         <IconButton
                         aria-label="expand row"
                         size="small"
                         onClick={() => {
                             let openf2 = JSON.parse(JSON.stringify(openF))
                             const n = openf2.indexOf(index)
                             if (n > -1) {
                                 openf2.splice(n, 1)
                             } else {
                                 openf2.push(index)
                             }
                             setOpenF(openf2);
                         }}
                     >
                         {openF.includes(index) ? (
                             <KeyboardArrowUpIcon />
                         ) : (
                             <KeyboardArrowDownIcon />
                         )}
                     </IconButton>
                  
                       
                    </TableCell>
                    <TableCell component="th" scope="row">
                        <b>{row.auditor}</b><br></br>
                        {row.rolName}
                    </TableCell>

                    <TableCell align="right">
                        {fecha}
                    </TableCell>
                    <TableCell align="right">
                        <b>{row.title}</b>
                    </TableCell>
                    <TableCell align="right">
                        {/* {ButtonTable(info[0], 1)} */}
                    </TableCell>
                </TableRow>
                {row.changes.map((item, index2) => {
                    return (<RenderItemFunction hora={hora} style={!openF.includes(index) ? { maxHeight: 0 } : {}} ty={row.ty} data={item} index={index} index2={index + "_" + index2}></RenderItemFunction>)
                })}

            </React.Fragment>
        )
    }
    function RenderItemFunction(props) {
        const row = props.data
        const index = props.index
        const index2 = props.index2
        const typeofrow = typeof row[1]
        const ty = props.ty

        // let switchStatus = (typeofrow !== "object" && row[1] !== row[2] || typeofrow === "object" && row[1].a !== row[2].a) ? ((typeofrow !== "object" && row[2]) || (typeofrow === "object" && row[2].a)) ? true : false : null

        let _old = JSON.parse(JSON.stringify(row[1]))
        let _new = JSON.parse(JSON.stringify(row[2]))

        let oldactive = row[1]
        let newactive = row[2]

        if (ty !== 1 && (_old.a||_old.a===false)) {
            oldactive = _old.a
            newactive = _new.a
            delete _old.a
            delete _new.a

            _old = JSON.stringify(_old)
            _new = JSON.stringify(_new)
        }


        let switchStatus = oldactive !== newactive ? newactive ? true : false : null
        // ((ty === 1 && oldactive !== newactive) || (ty !== 1 && oldactive !== newactive)) ? ((ty === 1 && row[2]) || (ty !== 1 && newactive)) ? true : false : null



        return (
            <React.Fragment  >
                <TableRow
                    style={!openF.includes(index) ? { height: "0px" } : {}}
                >
                    <TableCell style={!openF.includes(index) ? { height: "0px", border: 0, padding: 0 } : { padding: 5, border: 0, paddingLeft: '10px' }} colSpan={12}>
                        <Collapse in={openF.includes(index)} timeout="auto" unmountOnExit>
                            <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                <Grid xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: "center", fontSize: "small" }}>{props.hora}</Grid>
                                <Grid xs={10} style={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: '100%' }}>
                                    <Box
                                        width='100%'
                                        padding={0}
                                        backgroundColor="#dddddd"
                                        borderRadius={1}
                                        container
                                        direction="row"  >
                                        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                            <Grid xs={1} style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                                {typeofrow === "object" && _old !== _new ?
                                                    <TableCell style={{ padding: 0, display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                                        <IconButton
                                                            aria-label="expand row"
                                                            size="small"
                                                            onClick={() => {
                                                                let openi2 = JSON.parse(JSON.stringify(openI))
                                                                const n = openi2.indexOf(index2)
                                                                if (n > -1) {
                                                                    openi2.splice(n, 1)
                                                                } else {
                                                                    openi2.push(index2)
                                                                }
                                                                setOpenI(openi2);
                                                            }}
                                                        >
                                                            {openI.includes(index2) ? (
                                                                <KeyboardArrowUpIcon />
                                                            ) : (
                                                                <KeyboardArrowDownIcon />
                                                            )}
                                                        </IconButton>
                                                    </TableCell>
                                                    : null}
                                            </Grid>

                                            <Grid xs={8} style={{ display: 'flex', justifyContent: 'start', alignContent: "center" }}>
                                                <TableCell component="th" scope="row" style={{ fontWeight: "bold", padding: 10 }} >
                                                    {texts[row[0]]}
                                                </TableCell>
                                            </Grid>
                                            <Grid xs={3} style={{ display: 'flex', justifyContent: 'end', alignContent: "center" }}>
                                                {(switchStatus || switchStatus === false) ?
                                                    <TableCell xs={3} component="th" scope="row" style={{ fontWeight: "bold", padding: 0 }}>
                                                        {switchStatus ? "On" : "Off"} <Switch disabled checked={switchStatus} />
                                                    </TableCell>
                                                    : null}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </TableCell>
                </TableRow>

                {
                    typeof row === "object" && _old !== _new && openF.includes(index) ?

                        <RenderSubItem hora={props.hora} style={!openI.includes(index2) ? { maxHeight: 0 } : {}} index={index2} ty={props.ty} item={row}></RenderSubItem>
                        : null
                }
            </React.Fragment >
        )

    }

    const getColorText = (value) => {

        return !value
            ? "#20dfb1"
            : "#ffe1b5";
    };

    const getColorBg = (value) => {

        return !value ?
            "#9cffe7"
            : "#ff9800";

    };

    const getText = (value) => {

        return !value ? "TOLERANTE"
            : "ESTRICTO";
    };

    const ButtonTable = (value) => (
        <Button
            simple={false}
            size="sm"
            style={{ border: "solid", color: getColorText(value), backgroundColor: getColorBg(value), fontWeight: "bold" }}
            disabled
        >
            {getText(value)}
        </Button>
    );


    function RenderSubItem(props) {
        const item = props.item
        const index = props.index
        const _old = item[1]
        const _new = item[2]
        const ty = props.ty
        return (<TableRow style={!openI.includes(index) ? { height: "0px" } : {}} >
            <TableCell style={!openI.includes(index) ? { height: "0px", border: 0, padding: 0 } : { padding: 5, paddingLeft: '50px', border: 0 }} colSpan={12}>
                <Collapse in={openI.includes(index)} timeout="auto" unmountOnExit>
                    <Box marginTop={1}
                        padding={0}

                        borderRadius={1}
                        container
                        direction="row">
                        <Timeline
                            sx={{
                                [`& .${timelineItemClasses.root}:before`]: {
                                    flex: 0,
                                    padding: 0,
                                },
                            }}
                        >


                            {(_old.sm === true || _old.sm === false) && _new.sm !== _old.sm ?
                                <TimelineItem style={{ justifyContent: 'center', alignItems: 'center', marginTop: '-15px' }}>
                                    <TimelineSeparator>
                                        <TimelineDot style={{ padding: '2px', }} />
                                        {/* <TimelineConnector /> */}
                                    </TimelineSeparator>
                                    <TimelineContent xs={1} style={{ maxWidth: '100px', display: 'flex', justifyContent: "center", alignItems: "center", padding: 0, marginTop: 0, fontSize: "small" }} color="text.secondary">
                                        {props.hora}
                                    </TimelineContent>
                                    <TimelineContent style={{ marginTop: 0, paddingTop: 0 }}>
                                        <Grid
                                            marginTop={1}
                                            style={{ marginTop: 0, paddingTop: 0 }}
                                            padding={0}
                                            backgroundColor="#e0e0e0"
                                            borderRadius={1}
                                            container
                                            direction="row"
                                        >
                                            <Grid style={{ display: 'flex', justifyContent: "center", alignItems: "center", padding: 0, marginTop: 0, fontWeight: "bold" }} item xs={3}>
                                                <Typography variant="subtitle2" style={{ margin: 0, fontSize: '12px' }} gutterBottom>Modalidad</Typography>
                                            </Grid>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "flex-end" }} item xs={9}>

                                                <Grid
                                                    style={{ marginTop: 0, paddingTop: 0 }}
                                                    padding={0}
                                                    container
                                                    direction="row"
                                                >
                                                    <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }} item xs={5}>
                                                        {ButtonTable(_old.sm)}
                                                    </Grid>
                                                    <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "center", alignItems: "center" }} item xs={2}>
                                                        <ChevronRightIcon style={{ display: 'flex', justifyContent: 'flex-start', alignContent: "flex-start" }} />
                                                    </Grid>
                                                    <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }} item xs={5}>
                                                        {ButtonTable(_new.sm)}

                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                        {/* <TableRow style={{backgroundColor:"#aaa"}}><TableCell>{texts[item[0]]}</TableCell> <TableCell> <ButtonTable value={_old.ip}  /> </TableCell><TableCell>a </TableCell> <TableCell><ButtonTable value={_new.ip}  /> </TableCell></TableRow> */}
                                    </TimelineContent>
                                </TimelineItem>
                                : null}
                            {_new.l && (_new.l.new) ?
                                (_new.l.new ? _new.l.new : []).map((newit) => (
                                    <TimelineItem style={{ justifyContent: 'center', alignItems: 'center', marginTop: '-15px' }}>
                                        <TimelineSeparator>
                                            <TimelineDot style={{ padding: '2px', }} />
                                            {/* <TimelineConnector /> */}
                                        </TimelineSeparator>
                                        <TimelineContent xs={1} style={{ maxWidth: '100px', display: 'flex', justifyContent: "center", alignItems: "center", padding: 0, marginTop: 0, fontSize: "small" }} color="text.secondary">
                                            {props.hora}
                                        </TimelineContent>
                                        <TimelineContent style={{ marginTop: 0, paddingTop: 0 }}>
                                            <Grid
                                                marginTop={1}
                                                style={{ marginTop: 0, paddingTop: 0 }}
                                                padding={0}
                                                borderRadius={1}
                                                container
                                                direction="row"
                                                backgroundColor="#e0e0e0">
                                                <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "center", fontWeight: "bold", alignItems: "center" }} item xs={6}>
                                                    <Typography variant="subtitle2" style={{ margin: 0, fontSize: '12px' }} gutterBottom>Administración de {item[0] ? "procesos" : "cámaras virtuales"}</Typography>
                                                </Grid>


                                                <Grid style={{ display: 'flex', justifyContent: 'flex-end', alignContent: "center", alignItems: "center" }} item xs={6}>
                                                    <Typography variant="subtitle2" style={{ margin: 0, fontSize: '12px' }} gutterBottom><AddCircleOutlineIcon fontSize={"small"} /> Nuevo</Typography> <Typography variant="body2" style={{ marginLeft: "15px", fontSize: '15px', paddingRight: "15px" }} gutterBottom>{newit}</Typography>
                                                </Grid>

                                            </Grid>

                                        </TimelineContent>
                                    </TimelineItem>
                                ))

                                : null}
                            {_new.l && (_new.l.del) ?
                                (_new.l.del ? _new.l.del : []).map((delit) => (
                                    <TimelineItem style={{ justifyContent: 'center', alignItems: 'center', marginTop: '-15px' }}>
                                        <TimelineSeparator>
                                            <TimelineDot style={{ padding: '2px', }} />
                                            {/* <TimelineConnector /> */}
                                        </TimelineSeparator>
                                        <TimelineContent xs={1} style={{ maxWidth: '100px', display: 'flex', justifyContent: "center", alignItems: "center", padding: 0, marginTop: 0, fontSize: "small" }} color="text.secondary">
                                            {props.hora}
                                        </TimelineContent>
                                        <TimelineContent style={{ marginTop: 0, paddingTop: 0 }}>
                                            <Grid
                                                marginTop={1}
                                                style={{ marginTop: 0, paddingTop: 0 }}
                                                padding={0}
                                                container
                                                borderRadius={1}
                                                direction="row"
                                                backgroundColor="#e0e0e0">
                                                <Grid style={{ display: 'flex', justifyContent: 'center', alignContent: "center", fontWeight: "bold", alignItems: "center" }} item xs={6}>
                                                    <Typography variant="subtitle2" style={{ margin: 0, fontSize: '12px' }} gutterBottom>Administración de procesos</Typography>
                                                </Grid>


                                                <Grid style={{ display: 'flex', justifyContent: 'flex-end', alignContent: "center", alignItems: "center" }} item xs={6}>
                                                    <Typography variant="subtitle2" style={{ margin: 0, fontSize: '12px' }} gutterBottom><DeleteOutlineIcon fontSize={"small"} /> Eliminado</Typography> <Typography variant="body2" style={{ marginLeft: "15px", paddingRight: "15px", fontSize: '15px' }} gutterBottom>{delit}</Typography>
                                                </Grid>

                                            </Grid>

                                        </TimelineContent>
                                    </TimelineItem>
                                ))
                                : null}
                        </Timeline>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow >)
    }
    const fmap = () => {


        return logs.map((row, index) => (<RenderItemCategory index={index} data={row}></RenderItemCategory>))


    }



    const handleChange = (event) => {
        if (event.target.value === "todos") {
            setUser(null);

        }
        else {
            setUser(event.target.value);
        }
    };

    // const rows = [logs.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map]

    return (
        <div style={{ display: "flex", flexDirection: "column", maxHeight: '100%' }}>
            <GridContainer>
                <GridItem xs={3} sm={3} md={3} lg={3} xl={3} style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                    <Typography variant="h5" bold style={{ margin: 15 }}>
                        {"Acceso"}
                    </Typography>
                </GridItem>
                <GridItem xs={8} sm={8} md={8} lg={8} xl={8} />
                {/* <GridItem  xs={1} sm={1} md={1} lg={1} xl={1} style={{ display: 'flex', justifyContent: 'center', alignContent: "center", alignItems: "center" }}>
        <ManageSearchOutlinedIcon cursor="pointer" onClick={() => {
          actionData(valueSince.valueOf(), valueTo.valueOf())
        }} />
        </GridItem> */}
                <GridItem xs={1} sm={1} md={1} lg={1} xl={1} style={{ display: 'flex', justifyContent: 'center', alignContent: "center", alignItems: "center", marginLeft: "inherit" }}>
                    <CachedOutlinedIcon cursor="pointer" onClick={() => {
                        actionData(valueSince.valueOf(), valueTo.valueOf(),1)
                    }} />
                </GridItem>
            </GridContainer>

            <GridContainer style={{ paddingLeft: 15, paddingRight: 15 }}>
                {/* Usuario */}


                {/** data range picker */}
                <GridItem xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Usuario</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={user}
                            label="Usuario"
                            onChange={handleChange}
                        >
                            <MenuItem value={'todos'}>Todos</MenuItem>

                            {users.map((a, b) => (
                                <MenuItem key={b} value={a.id}>{a.email}</MenuItem>

                            ))}
                        </Select>
                    </FormControl>

                </GridItem>
                <GridItem
                    xs={12}
                    md={4}
                >
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        {/* <Stack direction="row" spacing={3}> */}
                        <DatePicker
                            disableFuture
                            label="Desde"
                            openTo="day"
                            views={["day", "month", "year"]}
                            inputFormat="DD/MM/YYYY"
                            value={valueSince}
                            onChange={(newValue) => {
                                setValueSince(newValue);
                            }}
                            renderInput={(params) => <TextField color="grayColor" variant="outlined" {...params} />}
                        />

                        {/* </Stack> */}
                    </LocalizationProvider>
                </GridItem>
                <GridItem
                    xs={12}
                    md={4}
                >


                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        {/* <Stack direction="row" spacing={3}> */}
                        <DatePicker
                            disableFuture
                            label="Hasta"
                            openTo="day"
                            inputFormat="DD/MM/YYYY"
                            views={["day", "month", "year"]}
                            value={valueTo}
                            onChange={(newValue) => {
                                setValueTo(moment(newValue).endOf('day'));
                            }}
                            renderInput={(params) => <TextField variant="outlined" {...params} />}
                        />
                        {/* </Stack> */}
                    </LocalizationProvider>
                </GridItem>
            </GridContainer>

            {/* tabla */}
            <TableContainer style={{ padding: 20, background: "none" }}>
                <Table aria-label="simple table">
                    <TableHead style={{ borderStyle: "none none solid none" }}>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Usuario</TableCell>
                            <TableCell align="right">Fecha</TableCell>
                            <TableCell align="right">Categoría</TableCell>
                            {/* <TableCell align="right">&nbsp;</TableCell> */}
                        </TableRow>
                    </TableHead>
                    {
                        loading || (!logs || logs.length < 1) ? null
                            :
                            <TableBody style={{ padding: 0, margin: 0 }}>{fmap()}</TableBody>
                    }
                </Table>
                {
                    loading ?
                        <div style={{ width: '100%', display: "flex", justifyContent: "center", paddingTop: 20, paddingBottom: 20 }}>
                            <CircularProgress /></div> :
                        null
                }
                {!loading && (!logs || logs.length < 1) ?



                    <Typography style={{ width: "100%", textAlign: "center", paddingTop: '10px', paddingBottom: '5px', }} variant="subtitle2" gutterBottom>No se encontraron modificaciones.</Typography> : null

                }
                {totalRegistry>0?
                <div
                    style={{ paddingBottom: 20, width: "100%" }}
                >
                    <BivPagination

                        onClickPrev={() => {
                            if (pageNumber !== 1) {

                                // pageNumberChange()
                                actionData(valueSince.valueOf(), valueTo.valueOf(), (pageNumber - 1))
                            }
                        }}
                        onClickPage={(value) => {
                            // pageNumberChange(value)
                            actionData(valueSince.valueOf(), valueTo.valueOf(), value)
                        }}
                        onClickNext={() => {
                            if (pageNumber !== totalRegistry) {
                                // pageNumberChange(pageNumber + 1)
                                actionData(valueSince.valueOf(), valueTo.valueOf(), (pageNumber + 1))
                            }
                        }}
                        page={pageNumber}
                        totalRegistry={totalRegistry}
                    />
                </div>
                :null}
            </TableContainer>

        </div>
    );
}
